export const getComparatorConfigQuery = `query GetComparatorConfig($clientName: String!, $comparatorId: String!) {
    comparatorConfigs(
      where: {
        clientName: { eq: $clientName }
        and: { comparatorId: { eq: $comparatorId } }
      }
    ) {
      nodes {
        clientName
        comparatorId
        id
        afmLicense {
          number
          name
          isUrl
          url
        }
      }
    }
  }
    `;
